module.exports = __webpack_public_path__ + "img/retrospect-52.f9a6b51c.jpg";